export default {
  annualRecurringIterationBenefit1: {
    id: 'insurance_radio_annual_recurring_iteration_monthly_benefit_1',
    defaultMessage: 'Cracked screen, water damage, any fault - we step in.',
  },
  annualRecurringIterationBenefit2: {
    id: 'insurance_radio_annual_recurring_iteration_monthly_benefit_2',
    defaultMessage: 'Unlimited repair requests.',
  },
  annualRecurringIterationBenefit3: {
    id: 'insurance_radio_annual_recurring_iteration_monthly_benefit_3',
    defaultMessage: 'Repairs at no additional cost.',
  },
  annualRecurringIterationBenefit4: {
    id: 'insurance_radio_annual_recurring_iteration_monthly_benefit_4',
    defaultMessage: 'Fast 3-day mail-in repairs.',
  },
  annualRecurringIterationBenefit5: {
    id: 'insurance_radio_annual_recurring_iteration_monthly_benefit_5',
    defaultMessage: 'No questions asked. Decision in 24h.',
  },
}
